export async function subscribeToList({
  listId,
  companyId,
  phoneNumber,
  email,
}: {
  listId: string;
  companyId: string;
  phoneNumber?: string;
  email?: string;
}): Promise<any> {
  const options: RequestInit = {
    method: "POST",
    headers: {
      revision: "2024-02-15",
      "content-type": "application/json",
    },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                ...(email && { email }),
                ...(phoneNumber && { phone_number: phoneNumber }),
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId,
            },
          },
        },
      },
    }),
  };

  try {
    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${companyId}`,
      options,
    );

    if (response.status == 202 || response.status == 200) {
      return response;
    }

    const { errors } = await response.json();

    const error = errors[0];

    return error;
  } catch {
    throw Error("Something went wrong");
  }
}

export default (listId: string, companyId: string) => ({
  email: "",
  success: false,
  error: null,
  loading: false,
  invalid: false,
  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  async submit() {
    if (!this.email) {
      return (this.invalid = true);
    }

    if (!this.validateEmail(this.email)) {
      return (this.invalid = true);
    } else {
      this.invalid = false;
    }

    if (!listId) {
      this.error = "Missing List ID";
      return;
    }

    this.loading = true;

    try {
      const response: Response = await subscribeToList({
        listId,
        email: this.email,
        companyId,
      });

      if (response.status == 202 || response.status == 200) {
        this.success = true;

        this.$dispatch("close-popup");
      } else if (response.errors[0].code === "invalid") {
        this.invalid = true;
      } else {
        this.error = response.errors ? response.errors[0] : "Unknown error";
      }
    } catch (error) {
      this.error = "Something went wrong";
      throw error;
    } finally {
      this.invalid = false;
      this.loading = false;
    }
  },
});
